"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../../helpers/customPropTypes");

var _RawButton = require("../../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

var _Icon = require("../../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes3 = require("../propTypes");

var _tokens = require("../../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconSize = {
  small: 10,
  medium: 12,
  large: 14
};

var ToggleItem = function (_Component) {
  _inherits(ToggleItem, _Component);

  function ToggleItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToggleItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleItem.__proto__ || Object.getPrototypeOf(ToggleItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          item = _this$props.item;


      onClick(item.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToggleItem, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _props = this.props,
          icon = _props.icon,
          item = _props.item,
          isDisabled = _props.isDisabled,
          isFullWidth = _props.isFullWidth,
          isSelected = _props.isSelected,
          selectedColor = _props.selectedColor,
          size = _props.size;


      var itemClass = (0, _classnames2.default)("aclui-toggle__item", (_classNames = {}, _defineProperty(_classNames, "aclui-toggle__item--" + selectedColor, isSelected), _defineProperty(_classNames, "is-disabled", isDisabled), _classNames));

      var title = void 0;
      if (isFullWidth && typeof item.label === "string") title = item.label;

      return _react2.default.createElement(
        _RawButton2.default,
        {
          "aria-selected": isSelected,
          className: itemClass,
          isDisabled: isDisabled,
          onClick: this.handleClick,
          role: "button option",
          title: title
        },
        icon && _react2.default.createElement(_Icon2.default, {
          color: isDisabled ? _tokens2.default.color.blackLighten40 : _tokens2.default.textColor.icon,
          size: iconSize[size],
          type: isSelected && !isDisabled ? "check" : "times"
        }),
        item.label
      );
    }
  }]);

  return ToggleItem;
}(_react.Component);

ToggleItem.propTypes = {
  icon: _propTypes2.default.bool.isRequired,
  isDisabled: _propTypes2.default.bool.isRequired,
  isFullWidth: _propTypes2.default.bool.isRequired,
  isSelected: _propTypes2.default.bool.isRequired,
  item: _propTypes3.shapeOfItem.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  selectedColor: _propTypes3.oneOfColorType.isRequired,
  size: _customPropTypes.shirtSize
};

exports.default = ToggleItem;